import React from 'react';
import { Link } from 'react-router-dom';
import { 
  PhoneIcon, 
  EnvelopeIcon, 
  MapPinIcon
} from '@heroicons/react/24/outline';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: "Quick Links",
      links: [
        { name: "Home", href: "/" },
        { name: "Products", href: "/products" },
        { name: "About Us", href: "/about" },
        { name: "Contact", href: "/contact" },
        { name: "My Orders (Coming Soon)", href: "#", disabled: true },
        { name: "Wishlist (Coming Soon)", href: "#", disabled: true }
      ]
    },
    {
      title: "Popular Categories",
      links: [
        { name: "AIROTOR", href: "/products?category=AIROTOR" },
        { name: "MICROMOTOR", href: "/products?category=MICROMOTOR" },
        { name: "ENDODONTIC", href: "/products?category=ENDODONTIC" },
        { name: "ORTHODONTIC", href: "/products?category=ORTHODONTIC" },
        { name: "SURGICAL INSTRUMENTS", href: "/products?category=SURGICAL INSTRUMENTS" },
        { name: "View All Categories", href: "/products" }
      ]
    },
    {
      title: "Customer Service",
      links: [
        { name: "WhatsApp Support", href: "https://wa.me/918999250629", external: true },
        { name: "Return & Refund Policy (Coming Soon)", href: "#", disabled: true },
        { name: "Shipping Information (Coming Soon)", href: "#", disabled: true },
        { name: "Track Order (Coming Soon)", href: "#", disabled: true },
        { name: "Bulk Order Inquiry", href: "/contact" },
        { name: "Payment Methods (Coming Soon)", href: "#", disabled: true }
      ]
    }
  ];

  const socialLinks = [
    { name: "Facebook", href: "https://www.instagram.com/groupdentalshopee/", icon: "📘" },
    { name: "Instagram", href: "https://www.instagram.com/groupdentalshopee/", icon: "📷" },
    { name: "Twitter", href: "#", icon: "🐦" },
    { name: "LinkedIn", href: "#", icon: "💼" },
    { name: "YouTube", href: "#", icon: "📺" }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main footer content */}
      <div className="container-max section-padding py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-gradient-to-r from-primary-600 to-primary-700 p-2 rounded-lg">
                <span className="text-white font-bold text-xl">🦷</span>
              </div>
              <div>
                <span className="text-2xl font-bold text-white">TeethKart</span>
                <p className="text-xs text-gray-400 -mt-1">India's Leading Dental Store</p>
              </div>
            </div>
            
            <p className="text-gray-300 mb-6 text-sm leading-relaxed">
              Your trusted partner for premium dental equipment, instruments, and materials. 
              Serving dental professionals across India with quality products and expert support.
            </p>

            {/* Contact info */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-sm">
                <PhoneIcon className="h-5 w-5 text-primary-400 flex-shrink-0" />
                <span>+91-8999-250-629</span>
              </div>
              <div className="flex items-center space-x-3 text-sm">
                <EnvelopeIcon className="h-5 w-5 text-primary-400 flex-shrink-0" />
                <span>Omprahalladbhandary@gmail.com</span>
              </div>
              <div className="flex items-start space-x-3 text-sm">
                <MapPinIcon className="h-5 w-5 text-primary-400 flex-shrink-0 mt-0.5" />
                <span>
                  Group dental Shopee<br />
                  A102. Sai Sanman CHS Ltd<br />
                  Guru Nanak nagar. Opp. Varthak Eng. college.<br />
                  Vasai Road west 401202
                </span>
              </div>
            </div>
          </div>

          {/* Footer sections */}
          {footerSections.map((section, index) => (
            <div key={index}>
              <h3 className="font-semibold text-lg mb-4 text-white">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {link.external ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-300 hover:text-primary-400 transition-colors text-sm"
                      >
                        {link.name}
                      </a>
                    ) : link.disabled ? (
                      <span className="text-gray-500 cursor-not-allowed text-sm">
                        {link.name}
                      </span>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-gray-300 hover:text-primary-400 transition-colors text-sm"
                      >
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>



        {/* Newsletter signup */}
        {/* <div className="mt-12 p-6 bg-gray-800 rounded-lg">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="mb-4 md:mb-0">
              <h3 className="font-semibold text-lg mb-2 text-white">Stay Updated</h3>
              <p className="text-gray-300 text-sm">
                Subscribe to get special offers, updates, and dental industry news.
              </p>
            </div>
            <div className="flex w-full md:w-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 md:w-64 px-4 py-2 bg-gray-700 text-white rounded-l-lg border border-gray-600 focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              />
              <button className="bg-primary-600 hover:bg-primary-700 text-white px-6 py-2 rounded-r-lg transition-colors">
                Subscribe
              </button>
            </div>
          </div>
        </div> */}
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-800">
        <div className="container-max section-padding py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              <p>© {currentYear} TeethKart. All rights reserved.</p>
              <p className="mt-1">Crafted with ❤️ in India</p>
            </div>

            {/* Social links */}
            <div className="flex items-center space-x-4">
              <span className="text-gray-400 text-sm mr-2">Follow us:</span>
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="text-gray-400 hover:text-primary-400 transition-colors text-lg"
                  title={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>

            {/* Trust badges */}
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              <div className="bg-green-600 text-white px-3 py-1 rounded text-xs font-medium">
                ✓ 100% Genuine
              </div>
              <div className="bg-blue-600 text-white px-3 py-1 rounded text-xs font-medium">
                🚚 Free Shipping
              </div>
              <div className="bg-purple-600 text-white px-3 py-1 rounded text-xs font-medium">
                🔒 Secure Payment
              </div>
            </div>
          </div>

          {/* Legal links */}
          <div className="mt-4 pt-4 border-t border-gray-800 flex flex-wrap justify-center md:justify-start space-x-6 text-xs text-gray-400">
            <Link to="/privacy" className="hover:text-primary-400 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-primary-400 transition-colors">Terms of Service</Link>
            <Link to="/refund" className="hover:text-primary-400 transition-colors">Refund Policy</Link>
            <Link to="/sitemap" className="hover:text-primary-400 transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
